import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import Formations from "../components/Formations"
import Campus from "../components/Campus"
import { AcademicLevel, Consentement, ConsentementMultiple, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber, RadioButton } from "components/fields"
import { useForms, useSalesforce, useUrlReturn } from "hooks"
import { consent, consentement, defaultValues, salutations, specialities } from "services"
import MentionsLegales from "components/MentionsLegales"

const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn('IPSA-DOC')
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...consent,
      ...specialities,
      campus: [],
      formations: [],
      lead: {
        ...defaultValues,
        ...specialities.lead,
        ...consentement,
        Bachelor__c: false,
        CycleInge__c: false,
        MidYearSession__c: false,
        Salutation: '',
        Section__c: '',
      }
    },
    resolver: yupResolver(schema)
  })
  const { control } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campus = lead.Campus__c
    const defaultDataLead = {
      Division__c: 'IPSA',
      IONISSchool__c: 'IPSA',
      LastForm__c: 'Documentation PDF',
      LeadSource: 'Internet: Demande de doc',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      await salesforce.createLead(finalLead)
      document.location.href=`${url}?campus=${campus}&niveau=${encodeURIComponent(lead.AcademicLevel__c)}`
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  // useEffect
  useSalesforce('EngineeringSchoolLead')

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RadioButton control={control} label="Civilité" name="lead.Salutation" options={salutations} required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel school="IPSA" />
        <Campus />
        <Formations />
        <ConsentementMultiple />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="Documentation" school="IPSA" />
      </Grid>
    </FormProvider>
  )
}

export default Form
